import React, { Fragment } from 'react'
import Link from "next/link";
import HeaderTopbar from "./theme/components/HeaderTopbar";
import MobileMenu from "./theme/components/MobileMenu";
import { applyLang, LangSelect, useTranslator } from "../../i18n";
import { buildDynamicArticlesMenuItems, buildContentHubHomeUrlForSite } from "../../components/ContentHub/utils";
import { buildMenuUrl } from "../../components/normalizeMenuUrl";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default class Header extends React.Component {

    navRef = React.createRef()

    ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    // Les sous-menus s'ouvrent au :hover (CSS). Comme Next.js navigue sans reload,
    // après un clic la souris reste sur l'item et le menu resterait ouvert. Au clic
    // sur un lien, on force la fermeture via une classe, puis on blur. La classe est
    // retirée au mouseleave de la nav → re-survol fonctionne normalement.
    handleNavClick = (e) => {
        const link = e.target.closest("a")
        if (!link || !this.navRef.current || !this.navRef.current.contains(link)) return
        this.navRef.current.classList.add("ummah-nav--suppress")
        if (typeof link.blur === "function") link.blur()
    }

    handleNavLeave = () => {
        this.navRef.current?.classList.remove("ummah-nav--suppress")
    }

    getCaisse() {
        const { org } = this.props.context

        return org.caisses
            .filter((c) => (c.payed < c.objectif || !c.withObjectif) && c.active && !c.paused && !c.hidden)
            .sort((a, b) => a.withObjectif - b.withObjectif)
            .map(i => applyLang(i, this.props.context.lang))
    }

    renderCaisses() {
        const { org, config } = this.props.context
        const caisses = this.getCaisse()

        var mainLabel = config["don.main.label"] || t`Don Spontané`

        if (caisses.length === 0) {
            return null
        }

        return (
            <ul>
                <li>
                    <Link href={org.BASE_WEB_URL + "/don"}>
                        {mainLabel}
                    </Link>
                </li>

                {caisses.map(item => {
                    return (
                        <li>
                            <Link href={org.BASE_WEB_URL + "/don/" + item.id}>
                                {item.name}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        )
    }

    // Retourne le menu enrichi : web_menu + items virtuels (récursifs) générés pour
    // chaque menu DYNAMIC_ARTICLES à partir de l'arbre ContentHub préchargé en SSR.
    // Mémoïsé pour ne pas recalculer à chaque appel récursif de renderChildMenu.
    getEffectiveMenu() {
        if (this._effectiveMenu) return this._effectiveMenu
        const { org, contentHubCategories } = this.props.context
        const base = org.web_menu || []
        const site = contentHubCategories?.site
        let extra = []
        for (const m of base) {
            if (m && m.type === "DYNAMIC_ARTICLES") {
                extra = extra.concat(
                    buildDynamicArticlesMenuItems(contentHubCategories?.items, m.id, site, org)
                )
            }
        }
        this._effectiveMenu = [...base, ...extra]
        return this._effectiveMenu
    }

    renderChildMenu(parent) {
        const context = this.props.context
        const { org } = context
        const fullMenu = this.getEffectiveMenu()
        const menu = fullMenu.filter(i => i.parent === parent)

        if (menu.length === 0) {
            return null
        }

        return (
            <ul>
                {menu.map(item => {
                    item = applyLang(item, context.lang)
                    // buildMenuUrl gère relatif, absolu-réécrit, slug nu (préfixé) et
                    // schémas (intacts) — cf. components/normalizeMenuUrl.js.
                    const url = buildMenuUrl(item.url, org)
                    const isSubExist = fullMenu.filter(i => i.parent === item.id).length > 0
                    return (
                        <li key={item.id}>
                            {isSubExist && <i className="fa fa-angle-right" />}
                            <Link href={url}>
                                {item.name}
                            </Link>
                            {this.renderChildMenu(item.id)}
                        </li>
                    )
                })}
            </ul>
        )

    }

    render() {
        const context = this.props.context
        const { org, config } = context
        const menu = org.web_menu

        if (context.render === "embed") {
            return null
        }

        return (
            <div className="middle-header">
                <HeaderTopbar context={context} />
                <div className="header-style-3">
                    <div className="container">
                        <div className="header-content">
                            <div className="row">
                                <div className="col-lg-1 col-md-1 col-sm-6 col-6">
                                    <div className="logo" style={{ cursor: "pointer" }}>
                                        <Link onClick={this.ClickHandler} href={config["orgLogoUrl"] || org.BASE_WEB_URL}>
                                            <div>
                                                <img className={"d-none d-md-block"} src={org.logo} style={{ height: "60px" }} />
                                                <div className="d-md-none d-flex align-items-center">
                                                    <img src={org.logo} style={{ height: "60px", marginRight: 10 }} />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-11 d-lg-block d-none">
                                    <nav ref={this.navRef} onClick={this.handleNavClick} onMouseLeave={this.handleNavLeave}>
                                        <ul>
                                            {!org.limited && (
                                                <Fragment>
                                                    {menu.filter(i => !i.parent).map(item => {
                                                        const isDynamic = item.type === "DYNAMIC_ARTICLES"
                                                        const localized = applyLang(item, context.lang)
                                                        let url = localized.url || ""
                                                        if (isDynamic) {
                                                            url = buildContentHubHomeUrlForSite(org, context.contentHubCategories?.site)
                                                        } else {
                                                            url = buildMenuUrl(url, org)
                                                        }
                                                        return (
                                                            <li key={item.id}>
                                                                <Link href={url}>{localized.name}</Link>
                                                                {this.renderChildMenu(item.id)}
                                                            </li>
                                                        )
                                                    })}

                                                    {config["menu.galerie.active"] !== false && (
                                                        <li>
                                                            <Link href={org.BASE_WEB_URL + "/galeries"}><Trans>Galeries</Trans></Link>
                                                        </li>
                                                    )}
                                                    {config["menu.event.active"] !== false && (
                                                        <li>
                                                            <Link href={org.BASE_WEB_URL + "/evenements"}><Trans>Événements</Trans></Link>
                                                        </li>
                                                    )}
                                                    {config["menu.abo.active"] !== false && (
                                                        <li>
                                                            <Link href={org.BASE_WEB_URL + "/abonnements"}><Trans>Abonnements</Trans></Link>
                                                        </li>
                                                    )}
                                                    {config["menu.horaire.active"] !== false && (
                                                        <li>
                                                            <Link href={org.BASE_WEB_URL + "/horaires"}><Trans>Horaires</Trans></Link>
                                                        </li>
                                                    )}
                                                    {config["menu.don.active"] !== false && (
                                                        <li>
                                                            <Link href={org.BASE_WEB_URL + "/don"}><Trans>Don Spontané</Trans></Link>
                                                            {this.renderCaisses()}
                                                        </li>
                                                    )}
                                                </Fragment>
                                            )}

                                            {org.limited && (
                                                <li>
                                                    <Link href={org.BASE_WEB_URL}><Trans>Accueil</Trans></Link>
                                                </li>
                                            )}
                                        </ul>
                                    </nav>
                                </div>

                                <div className="col-md-none col-sm-6 col-6 row align-content-center">
                                    <MobileMenu context={context} />
                                </div>
                            </div>

                            <div className="clearfix"></div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }

}
